import { useCallback } from "react";
import { useAppSelector } from "@/redux/hooks";
import { FileFormat, FileTypeGrouping } from "@/constants/constants";
import { selectFileTypeGroupings, selectFileTypeGroupingsFromApi } from "@/redux/selectors/constantsSelectors";

const useFileType = () => {
  const fileTypeGroupingsFromCommon = useAppSelector(selectFileTypeGroupings);
  const fileTypeGroupingsFromApi = useAppSelector(selectFileTypeGroupingsFromApi);
  const fileTypeGroupings = fileTypeGroupingsFromApi ?? fileTypeGroupingsFromCommon;

  return useCallback((fileType: string) => {
    const group = Object.keys(fileTypeGroupings).find((group) => {
      if (fileTypeGroupings[group as keyof FileTypeGrouping].includes(fileType as FileFormat)) {
        return group;
      }
    });
    return group;
  }, [fileTypeGroupings]);
};

export default useFileType;